import { Checkbox, DialogContent, DialogContentText, FormControlLabel } from '@mui/material'
import { useState } from 'react'

import ConfirmDialogActions from '@/components/feedback/ConfirmDialogActions'
import CustomDialog from '@/components/feedback/CustomDialog'
import { useAlertContext } from '@/contexts/AlertContext'
import { useFlexBalanceSteeringMutation } from '@/features/flexBalance/hooks/useFlexBalanceSteeringMutation'
import { SteeringCommand } from '@/features/flexBalance/types'

export type ResourceSteerModalProps = {
  resourceName: string | undefined
  open: boolean
  handleClose: () => void
  command: SteeringCommand | undefined
}

export const ResourceSteeringModal = (props: ResourceSteerModalProps) => {
  const { pushAlert } = useAlertContext()
  const { steerResource } = useFlexBalanceSteeringMutation()
  const [continuousSteering, setContinuousSteering] = useState<boolean>(false)

  const handleCommand = () => {
    closeSteeringModal()
    if (props.command) {
      return steerResource({ steeringCommand: props.command, continuousSteering: continuousSteering })
    }
  }

  const handleCommandCancel = () => {
    pushAlert({
      severity: 'error',
      message:
        props.command === SteeringCommand.STEER
          ? 'The resource will not be steered'
          : 'The resource will not be released',
    })
    closeSteeringModal()
  }

  const closeSteeringModal = () => {
    props.handleClose()
  }

  return (
    <CustomDialog open={props.open} title="Steer Resource" onClose={() => closeSteeringModal}>
      <DialogContent sx={{ paddingBottom: '0 !important', paddingTop: '0 !important' }}>
        {props.command === SteeringCommand.STEER ? (
          <>
            <DialogContentText>{`Do you want to steer the resource named ${props.resourceName}?'`}</DialogContentText>
            <FormControlLabel
              control={
                <Checkbox
                  checked={continuousSteering}
                  color="primary"
                  onChange={() => setContinuousSteering((prev) => !prev)}
                />
              }
              label={'Steer continuously based on Nowcasting model'}
            ></FormControlLabel>
          </>
        ) : (
          <DialogContentText>{`Do you want to release the resource named ${props.resourceName}?'`}</DialogContentText>
        )}
      </DialogContent>
      <ConfirmDialogActions disabled={false} onCancel={handleCommandCancel} onConfirm={handleCommand} />
    </CustomDialog>
  )
}
